import ScrollToTop from '../helpers/ScrollTop';
import Header from '../header/Header';
import Footer from '../banners/footer/Footer';
import Container from '../container/Container';
import TitleWrapper from '../titles/wrapper/TitleWrapper';
import ShowAnimation from '../helpers/ShowAnimation';
import H1title from '../titles/H1title';
import Description from '../description/Description';
import BannerTopSection from '../bannerTopSection/BannerTopSection';
import {useEffect, useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {useBlogContext} from '../BlogContext';
import {useParams} from 'react-router-dom';
import ListPosts from '../blog/ListPosts';
import PostView from '../blog/PostView';

export default function Blog() {
  const {t} = useTranslation();
  const ref1 = useRef();

  const {blogList, loadBlogList} = useBlogContext();
  const {id} = useParams();

  useEffect(() => {
    if (!blogList) {
      fetch('/blog/_blog-list.json').then(file => {
        loadBlogList(file)
      })
    }
  }, [blogList, loadBlogList]);

  return (
    <>
      <ScrollToTop/>
      <Header/>
      {
        !!id && blogList && <PostView id={id} type={'post'}/>
      }
      {
        !id && <>
          <BannerTopSection>
            <Container>
              <TitleWrapper ref={ref1}>
                <ShowAnimation ref={ref1} order={1} direction={'v'}>
                  <H1title isWhite={true}>{t('blog.title')}</H1title>
                </ShowAnimation>
                <ShowAnimation ref={ref1} order={2} direction={'v'}>
                  <Description>
                    {t('blog.description')}
                  </Description>
                </ShowAnimation>
              </TitleWrapper>
            </Container>
          </BannerTopSection>
          <Container>
            {blogList && <ListPosts posts={blogList.posts}/>}
          </Container>
        </>
      }
      <Footer/>
    </>
  )
}